import React from 'react';

import {
  ChakraFlex,
  ChakraText,
  EquipUITheme,
  Message,
} from '@equip.health/ui';

const { h4, paragraph } = EquipUITheme.typography;

const idPrefix = 'no';
const idPostfix = 'messages';

interface NoMessagesStateProps {
  id: string;
  isChannelReadonly: boolean;
}

const NoMessagesState = React.forwardRef<
  HTMLInputElement,
  NoMessagesStateProps
>(
  (
    { id, isChannelReadonly }: NoMessagesStateProps,
    ref?: React.ForwardedRef<HTMLInputElement>,
  ) => {
    return (
      <ChakraFlex
        alignItems="center"
        direction="column"
        id={`${idPrefix}-messages-container__${id}__${idPostfix}`}
        paddingBottom="36px"
        ref={ref}
        textAlign="center"
      >
        <ChakraFlex justifyContent="center" paddingBottom="24px">
          <Message />
        </ChakraFlex>
        <ChakraText
          lineHeight="35px"
          paddingBottom="24px"
          {...h4}
          id={`${idPrefix}-messages-header-text__${id}__${idPostfix}`}
        >
          No messages yet!
        </ChakraText>
        <ChakraText
          lineHeight="28px"
          {...paragraph}
          id={`${idPrefix}-messages-text__${id}__${idPostfix}`}
        >
          Seems that we don&apos;t have any messages in the group yet.
          <br />
          {!isChannelReadonly && (
            <>
              You can be the first to send one, right below{' '}
              <span aria-label="smile" role="img">
                🙂
              </span>
            </>
          )}
        </ChakraText>
      </ChakraFlex>
    );
  },
);

NoMessagesState.displayName = 'NoMessagesState';
export default NoMessagesState;
